import gql from 'graphql-tag';

export interface GetAdmission {
  id?: number;
  course?: {
    id?: number;
    name?: string;
    descomplicaProviderCode?: string;
    descomplicaCurriculumId?: string;
  };
  campus?: {
    id?: number;
    name?: string;
    city?: string;
    state?: string;
  };
  admissionType?: {
    evaluationMethod?: string;
  } | null;
}

export interface GetAdmissionQueryResult {
  getAdmission: GetAdmission;
}

export interface CountyDTO {
  id: string;
  uf: string;
  county: string;
  countyFullName: string;
}
export interface CountyInputDTO {
  uf: string;
  id: string;
  county: string;
  cep: string;
}
export interface UfDTO {
  uf: string;
  name: string;
}

export interface CountyQueryResult {
  getCountys: CountyDTO[];
}

export const getCountys = gql`
  query {
    getCountys {
      id
      uf
      county
      countyFullName
    }
  }
`;

export const getCountysArgs = gql`
  query($args: CountyInput) {
    getCountys(args: $args) {
      id
      uf
      county
      countyFullName
    }
  }
`;

export const admissionsResultFields = `
  id
  course {
    id
    name
    descomplicaProviderCode
    descomplicaCurriculumId
  }
  campus {
    id
    name
    city
    state
  }
`;

// `admissionType` só aqui, não em `admissionsResultFields`: o `upsertAdmission` do
// backend não resolve esse campo. É ele que identifica a matrícula ProUni.
export const getAdmission = gql`
  query getAdmission {
    getAdmission {
      ${admissionsResultFields}
      admissionType {
        evaluationMethod
      }
    }
  }
`;
